export default "__VITE_ASSET__399188de__"